import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { makeThemeColor, TERTIARY } from '@tornado-rdk/theme';

export const INNER_BORDER_COLOR = makeThemeColor(TERTIARY);

export const ITEMS_BY_BREAKPOINTS = {
  general: {
    [HD]: 6,
    [FULL_HD]: 6,
  },
  search: {
    [HD]: 3,
    [FULL_HD]: 4,
  },
};
